import { cn } from "@/lib/utils";
import { FC } from "react";
import { ArrowDownIcon } from "./_arrow";

// Category Dropdowns Component
export const CategoryDropdowns: FC<{
    categories: any[];
    selectedItemsByCategory: Record<number, number>;
    onCategoryItemSelect: (categoryId: number, itemId: number) => void;
    openDropdown: number | null;
    onDropdownToggle: (categoryId: number | null) => void;
}> = ({ categories, selectedItemsByCategory, onCategoryItemSelect, openDropdown, onDropdownToggle }) => (
    <div className={cn(
        "flex flex-col gap-[10px] w-full relative z-20",
        "sm:flex-row sm:gap-[8px]",
        "md:gap-[10px]",
        "lg:gap-[12px]",
        "xl:gap-[12px]"
    )}>
        {categories.map((category) => (
            <div 
                key={category.id}
                className={cn(
                    "flex flex-col w-full relative",
                    "sm:w-[180px]",
                    "md:w-[210px]",
                    "lg:w-[245px]",
                    "xl:w-[245px]"
                )}
                style={{
                    zIndex: openDropdown === category.id ? 30 : 20
                }}
            >
                <p 
                    className={cn(
                        "font-semibold leading-[1.4] mb-[4px]",
                        "text-[14px] tracking-[0.14px]",
                        "sm:text-[10.5px] sm:tracking-[0.105px] sm:mb-[2px]",
                        "md:text-[12px] md:tracking-[0.12px] md:mb-[3px]",
                        "lg:text-[14px] lg:tracking-[0.14px] lg:mb-[4px]",
                        "xl:text-[14px] xl:tracking-[0.14px] xl:mb-[4px]"
                    )}
                    style={{
                        color: category.text_color || "#FFFFFF",
                        fontFamily: "var(--font-google-sans)"
                    }}
                >
                    {category.name}:
                </p>
                <div className={cn("relative w-full")}>
                    <button
                        onClick={() => onDropdownToggle(openDropdown === category.id ? null : (category.id as number))}
                        className={cn(
                            "w-full flex items-center justify-between font-medium leading-[1.4] transition-all",
                            "px-[10px] py-[10px] rounded-[10px] text-[14px] tracking-[0.14px] gap-[10px]",
                            "sm:px-[8px] sm:py-[8px] sm:rounded-[7.5px] sm:text-[10.5px] sm:tracking-[0.105px] sm:gap-[7.5px]",
                            "md:px-[9px] md:py-[9px] md:rounded-[9px] md:text-[12px] md:tracking-[0.12px] md:gap-[9px]",
                            "lg:px-[10px] lg:py-[10px] lg:rounded-[10px] lg:text-[14px] lg:tracking-[0.14px] lg:gap-[10px]",
                            "xl:px-[10px] xl:py-[10px] xl:rounded-[10px] xl:text-[14px] xl:tracking-[0.14px] xl:gap-[10px]"
                        )}
                        style={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            border: "0.6px solid rgba(255,255,255,0.4)",
                            color: "#FFFFFF",
                            fontFamily: "var(--font-google-sans)"
                        }}
                    >
                        <span className="flex-1 text-left whitespace-nowrap overflow-hidden text-ellipsis">
                            {category.items?.find((item: any) => item.id === selectedItemsByCategory[category.id as number])?.name || 
                             category.items?.[0]?.name || 
                             "Select"}
                        </span>
                        <ArrowDownIcon className={cn(
                            "shrink-0 size-[20px] transition-transform",
                            "sm:size-[15px]",
                            "md:size-[17px]",
                            "lg:size-[20px]",
                            "xl:size-[20px]",
                            openDropdown === category.id && "rotate-180"
                        )} />
                    </button>
                    
                    {/* Dropdown Menu */}
                    {openDropdown === category.id && category.items && category.items.length > 0 && (
                        <div 
                            className={cn(
                                "absolute z-50 w-full mt-[4px] overflow-hidden",
                                "rounded-[10px]",
                                "sm:rounded-[7.5px] sm:mt-[2px]",
                                "md:rounded-[9px] md:mt-[3px]",
                                "lg:rounded-[10px] lg:mt-[4px]",
                                "xl:rounded-[10px] xl:mt-[4px]"
                            )}
                            style={{
                                backgroundColor: "#1C1C1E",
                                border: "0.6px solid rgba(255,255,255,0.4)",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.6)"
                            }}
                        >
                            <div className="max-h-[200px] overflow-y-auto scrollbar-hide">
                                {category.items.map((item: any) => (
                                    <button
                                        key={item.id}
                                        data-cta-name="category_select"
                                        onClick={() => {
                                            onCategoryItemSelect(category.id as number, item.id as number);
                                            onDropdownToggle(null);
                                        }}
                                        className={cn(
                                            "w-full text-left font-medium leading-[1.4] transition-all hover:bg-white/10",
                                            "px-[10px] py-[10px] text-[14px] tracking-[0.14px]",
                                            "sm:px-[8px] sm:py-[8px] sm:text-[10.5px] sm:tracking-[0.105px]",
                                            "md:px-[9px] md:py-[9px] md:text-[12px] md:tracking-[0.12px]",
                                            "lg:px-[10px] lg:py-[10px] lg:text-[14px] lg:tracking-[0.14px]",
                                            "xl:px-[10px] xl:py-[10px] xl:text-[14px] xl:tracking-[0.14px]",
                                            selectedItemsByCategory[category.id as number] === item.id && "bg-white/20"
                                        )}
                                        style={{
                                            color: item.text_color || "#FFFFFF",
                                            fontFamily: "var(--font-google-sans)"
                                        }}
                                    >
                                        {item.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        ))}
    </div>
);